export const SUBMIT_SURVEY_PREVIEW_SUCCESS = "SUBMIT_SURVEY_PREVIEW_SUCCESS"
export const UPDATE_SURVEY_PREVIEW_LOADING = "UPDATE_SURVEY_PREVIEW_LOADING"
export const RESET_SURVEY_VIEW_DATA = "RESET_SURVEY_VIEW_DATA"
export const UPDATE_SURVEY_INPUT_REQUIRE_ERROR = "UPDATE_SURVEY_INPUT_REQUIRE_ERROR"
export const UPDATE_ANSWER_DATA = "UPDATE_ANSWER_DATA"
export const SWITCH_TOGGLE_EDIT = "SWITCH_TOGGLE_EDIT"